import { useCallback, useMemo, useRef, useState } from 'react'

import axios from 'axios'

const fetchCollectionItems = async ({ pageParam = 1, slug }) => {
  const { data } = await axios.get(`/products/${slug}/collection_items`, {
    params: { page: pageParam },
  })
  return data
}

// Plain manual pagination instead of @tanstack/react-query: the query engine
// added ~36 KB to the item page critical bundle while running with
// enabled: false (fetchNextPage is only ever called manually on swipe).
const useCollectionItems = (initialProducts, slug, hasMoreInitially) => {
  const [pages, setPages] = useState(() => [{ products: initialProducts, next: hasMoreInitially }])
  const [isFetchingNextPage, setIsFetchingNextPage] = useState(false)
  const isFetchingRef = useRef(false)

  const hasNextPage = Boolean(pages[pages.length - 1]?.next)

  const fetchNextPage = useCallback(async () => {
    if (isFetchingRef.current || !hasNextPage) return

    isFetchingRef.current = true
    setIsFetchingNextPage(true)

    try {
      const page = await fetchCollectionItems({ pageParam: pages.length + 1, slug })
      setPages((prev) => [...prev, page])
    } catch (error) {
      // Swallow so the next swipe retries: hasNextPage stays true
    } finally {
      isFetchingRef.current = false
      setIsFetchingNextPage(false)
    }
  }, [slug, hasNextPage, pages.length])

  const products = useMemo(
    () => pages.flatMap((page) => page.products),
    [pages]
  )

  return { products, fetchNextPage, hasNextPage, isFetchingNextPage }
}

export default useCollectionItems
